import axios from "axios";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { Loader } from "../Components/Loader";
import { Alert } from "../Components/Modal/Alert";
import { API } from "../Services/Api";
import {
  api_url,
  aplicacao,
  app_base_url,
  enderecos_api,
  itbi_sql_server_url,
  login_api,
} from "../Utils/Urls";

interface IUsuarioPrefeituraContextData {
  login(usuario: string, senha: string): Promise<void>;
  usuarioPrefeitura: UsuarioPrefeitura;
  logoutP():void;
  checarToken:()=>Promise<void>
  token:string;
}

interface IUsuarioPrefeituraProviderProps {
  children: ReactNode;
}

const UsuarioPrefeituraContext = createContext(
  {} as IUsuarioPrefeituraContextData
);
export const token_storage = "@login-unico";

interface UsuarioPrefeitura {
  usuario: {
    id: number;
    entidade_id: number;
    usuario: string;
    cpf: string;
    senha: string;
    email: string;
    inativo: string;
    nome: string;
    foto: string;
  };

  entidade: {
    id: number;
    titulo: string;
    banco: string;
    logo: string;
    apresentacao: string;
    portal: string;
    site: string;
    site2: string;
    pasta: string;
  };
  sistemas: Sistema[];
}

interface Sistema {
  id: number;
  titulo: string;
  url: string;
  usuario_id: number;
  sistema_id: number;
}

function UsuarioPrefeituraProvider({
  children,
}: IUsuarioPrefeituraProviderProps) {
  const [alert, setAlert] = useState({ titulo: "", mensagem: "" });
  const [loading, setLoading] = useState(false);
  const [usuarioPrefeitura, setUsuarioPrefeitura] = useState(
    {} as UsuarioPrefeitura
  );
  const [token, setToken] = useState("");

  function saveToken() {
    localStorage.setItem(token_storage, token);
    API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    //checarToken();
  }

  async function login(usuario: string, senha: string) {
    try {
      const { data } = await axios.post(`${login_api}/login-completo`, {
        usuario,
        senha,
      });
      if (data.status) {
        setUsuarioPrefeitura(data.data.login);
        setToken(data.data.token);

        API.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${data.data.token}`;
      } else {
        setAlert({ titulo: "Ops", mensagem: data.mensagem });
      }
    } catch (e) {
      console.log(e);
      setAlert({ titulo: "Ops", mensagem: "Login inválido" });
    } finally {
    }
  }

  async function checarToken() {
    setLoading(true);
    try {
      setLoading(true);
      const token = localStorage.getItem(token_storage);
      //window.alert(token)
      if (token) {
        const API_LOGIN = axios.create({
          baseURL: login_api,
        });

        API_LOGIN.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        const { data } = await API_LOGIN.get("/checar-token");
          //window.alert(JSON.stringify(data.usuario));
          //return;
        const permissao = data.usuario.sistemas.filter(
         (i: any) => i.titulo == aplicacao
       );
        if (permissao.length > 0) {
           // window.alert(data.usuario.entidade.banco.replace("1-", "").replace("2-", "").toLowerCase())
          // window.alert( `Bearer ${token}`);
           API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
             setUsuarioPrefeitura(data.usuario);

             
         }
      }
    } catch (error) {

    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if(token && token.length>0){
      localStorage.setItem(token_storage, token);
      API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      checarToken();
      saveToken();
    }
  
  }, [token]);

  useEffect(()=>{
    if(token.length==0){
      const _token = localStorage.getItem(token_storage);
      if(_token){
        setToken(_token)
      } 
    }
  },[])


  function logoutP(){
    localStorage.removeItem(token_storage);
    setUsuarioPrefeitura({} as UsuarioPrefeitura)
  }


  return (
    <UsuarioPrefeituraContext.Provider value={{ usuarioPrefeitura, login,logoutP,checarToken,token }}>
      <>
        {children}

        <Loader loading={loading} />
        <Alert
          alert={alert}
          onClose={() => setAlert({ titulo: "", mensagem: "" })}
          open={alert.mensagem.length > 0}
        />
      </>
    </UsuarioPrefeituraContext.Provider>
  );
}

function useUsuarioPrefeitura() {
  const context = useContext(UsuarioPrefeituraContext);

  return context;
}

export { UsuarioPrefeituraProvider, useUsuarioPrefeitura };
